<template>
    <div class="topnav hidden-xs" v-bind:class="{ agencyisloggedin: getFlagSharedAgencyLoggedIn === true }">
        <div class="container">
            <ul class="quick-menu pull-left">
                <li class="ribbon">
                    <a>{{ language[getCurrentLocale] }} ({{ getCurrentLocale }})</a>
                    <ul class="menu mini">
                        <li v-bind:class="{ active: getCurrentLocale === 'de' }">
                            <a href="#" title="Deutsch" v-on:click.prevent="changeLanguage('de')">Deutsch</a>
                        </li>
                        <li v-bind:class="{ active: getCurrentLocale === 'en' }">
                            <a href="#" title="English" v-on:click.prevent="changeLanguage('en')">English</a>
                        </li>
                    </ul>

                    <v-dialog/>
                </li>
            </ul>
            <!-- <ul class="quick-menu pull-right" v-if="getFlagSharedAgencyLoggedIn === false">
                <li><a href="#sundair-login" class="soap-popupbox">{{ agencylogin[getCurrentLocale] }}</a></li>
            </ul>

            <ul class="quick-menu pull-right" v-if="getFlagSharedAgencyLoggedIn === true">
                <li><a href="#" @click.prevent="onClick_AgencyLogout()">{{ agencylogout[getCurrentLocale] }}</a></li>
            </ul> -->
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                agencylogin: {
                    en: 'Agency Login',
                    de: 'Agentur Login',
                },
                agencylogout: {
                    en: 'Agency Logout',
                    de: 'Agentur Logout',
                },
                alertno: {
                    en: 'No',
                    de: 'Nein',
                },
                alertyes: {
                    en: 'Yes',
                    de: 'Ja',
                },
                dialogtitle: {
                    en: 'Change Language?',
                    de: 'Sprache ändern?',
                },
                dialogtext: {
                    en: 'You want to change the language?',
                    de: 'Sie wollen die Sprache ändern?',
                },
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn', // is Agency logged in?
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Check for Agency here.
        *
        */
		mounted: function () {

            let me = this,
                localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username')), // catch
                localStorageAgencyPass = JSON.parse(localStorage.getItem('sdr__agency_password')); // catch


            // >>> Agency in localStorage? --------------
            if (localStorageAgencyUser !== null) {
                this.actn_FlagSharedAgencyLoggedIn(true);
            }

        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_FlagSharedAgencyLoggedIn'
            ]),



            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_AgencyLogout()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return
            */
            onClick_AgencyLogout: function () {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> onClick_AgencyLogout');
                Vue.ls.remove('agency_username');
                Vue.ls.remove('agency_password');
                Vue.ls.remove('agency_object');

                this.actn_FlagSharedAgencyLoggedIn(false);
                me.$toasted.global.sdr_app_info({
                    message : 'Agency was logged out.'
                });

            }, // eof onClick_AgencyLogout()




            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * changeLanguage()
            *
            * Desc:
            * Note:
            *
            * @param {string} language ()
            * @param
            * @return
            */
            changeLanguage: function (language) {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> changeLanguage');
                this.$modal.show('dialog', {
                    title: me.dialogtitle[me.getCurrentLocale],
                    text:  me.dialogtext[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.lang = language;
                                this.$ls.set('lang', language); // localStorage

                                me.actn_setCurrentLocale(language);
                            }
                        }
                    ]
                });

            }, // eof changeLanguage()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .agencyisloggedin  {
        background-color: #3bdd4e !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/header/LanguageList.vue